module.exports = __webpack_public_path__ + "img/caliceo.59813fd4.svg";